import * as React from 'react';
import MyTypes from 'MyTypes';
import { connect, ConnectedProps } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Modal, Button, Form } from 'react-bootstrap'; 
import _ from 'lodash'; 
import { contactsActions } from 'store/contacts';
import * as models from '../../models';
import { claimsActions } from 'store/claims';
import { USER_ACTIONS } from 'store/enums';

interface Props extends PropsFromRedux {  
    claimsList: number[]; 
    showModal: boolean;
    closeModal: () => void;
}

interface State {    
    fieldAdjusterId: number; 
}

class AssignClaimModal extends React.Component<Props, State> {
    public state = {
        fieldAdjusterId: -1, 
    };

    componentDidUpdate(prevProps: any, prevState: any) {
        if(!_.isEqual(prevProps.lastUserAction, this.props.lastUserAction) && this.props.lastUserAction === USER_ACTIONS.BULK_ASSIGN_CLAIMS_SUCCESS){
            this.resetFormStateAndClose(); 
        }        
    }

    public resetFormStateAndClose = () => {
        this.props.requestClaimsList(this.props.claimsRequest); 
        this.setState({fieldAdjusterId: -1}); 
        this.props.closeModal(); 
    }

    public submitForm = (e:any) => {
        e.preventDefault();
        const request: models.AssignClaims = {
            adjusterId: this.state.fieldAdjusterId, 
            claims: this.props.claimsList, 
        }
        this.props.assignClaims(request); 
    }

    public render() {
        const { fieldAdjustersDD, isAdjustersDDLoading, showModal } = this.props;     
        const { fieldAdjusterId } = this.state; 

        const adjusterValue = isAdjustersDDLoading ? -1 : fieldAdjusterId;         
       
        return (
            <Modal centered={true} show={showModal} onHide={this.resetFormStateAndClose} >
                <Modal.Header closeButton>
                    <Modal.Title>Assign Claim(s)</Modal.Title>
                </Modal.Header>
                <Form className="claim-modal" onSubmit={(e) => this.submitForm(e)}>
                    <Modal.Body>           
                        <Form.Group>
                            <Form.Label>Field Adjuster</Form.Label>
                            <Form.Select 
                                name="fieldAdjuster" 
                                value={adjusterValue} 
                                onChange={(e) => this.setState({fieldAdjusterId: parseInt(e.target.value)})} 
                                >
                                <option key={-1} value="">Choose...</option>
                                {fieldAdjustersDD && fieldAdjustersDD.resourceList.map((x: models.DropDownListItem, i: number) =>
                                    <option key={i} value={x.id}>{x.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.resetFormStateAndClose}>
                            CANCEL
                        </Button>
                        <Button variant="primary" type="submit">
                            SAVE
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>            
        );
    }
}

const mapStateToProps = (state: MyTypes.RootState) => ({    
    claimsRequest: state.claims.search.claimsRequest, 
    fieldAdjustersDD: state.contacts.dropdowns.adjustersDD,
    isAdjustersDDLoading: state.contacts.dropdowns.isAdjustersDDLoading, 
    isBulkAssigning: state.claims.claim.isBulkAssigning, 
    lastUserAction: state.user.actions.lastUserAction,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {            
            assignClaims: claimsActions.assignClaimsRequest,
            requestAdjustersDD: contactsActions.requestAdjustersDD, 
            requestClaimsList: claimsActions.requestClaims,              
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AssignClaimModal);